import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { ReplaceTextPipe } from '../../pipes/replace-text.pipe';
import { BlockStyle, BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

const calcCustomLineHeight = (size: number) => {
  if (!size) return;
  if (size <= 24) return 1.2;
  if (size <= 48) return 1.2;
  return 1;
};

@Component({
  selector: 'app-title',
  standalone: true,
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
  imports: [CommonModule, BlockWrapperComponent, ReplaceTextPipe],
})
export class TitleComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];
  @Input() size: string;
  @Input() type: string;
  @Input() title: string;
  @Input() alignment: string;
  @Input() customLargeDesktopSize: number;
  @Input() customDesktopSize: number;
  @Input() customTabletSize: number;
  @Input() customMobileSize: number;

  @Input() customTextAlign: string;
  @Input() mobileAlignment: string;
  @Input() tabletAlignment: string;
  @Input() desktopAlignment: string;

  customMobileLineHeight: number;
  customTabletLineHeight: number;
  customDesktopLineHeight: number;
  customLargeDesktopLineHeight: number;

  ngOnChanges() {
    if (this.size === 'custom') {
      this.customMobileLineHeight = calcCustomLineHeight(this.customMobileSize);
      this.customTabletLineHeight = calcCustomLineHeight(this.customTabletSize);
      this.customDesktopLineHeight = calcCustomLineHeight(this.customDesktopSize);
      this.customLargeDesktopLineHeight = calcCustomLineHeight(this.customLargeDesktopSize);
    }
  }
}
